"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassroomParticipantActionEnum = void 0;
var ClassroomParticipantActionEnum;
(function (ClassroomParticipantActionEnum) {
  /** Могу снять назначение ассистента */
  ClassroomParticipantActionEnum["dismiss_assistant"] = "dismiss_assistant";
  /** Могу снять назначение заменяющего преподавателя */
  ClassroomParticipantActionEnum["dismiss_replacement_teacher"] = "dismiss_replacement_teacher";
})(ClassroomParticipantActionEnum = exports.ClassroomParticipantActionEnum || (exports.ClassroomParticipantActionEnum = {}));
